import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-brouillon-cmd-negoce',
  templateUrl: './brouillon-cmd-negoce.component.html',
  styleUrls: ['./brouillon-cmd-negoce.component.scss']
})
export class BrouillonCmdNegoceComponent implements OnInit {
    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('BrouillonCmdNegoceComponent initialized');
        this.dataService.filterOrdersByStatus('Brouillon');
    }
}
